import React from 'react';
import ReactDOM from 'react-dom';
import dompurify from 'dompurify';
import RbrConst from '../constants/rbr.constants';
import TopMenuConst from '../navbar/constants/top_menu.constants';
import { okrDetailConstants } from '../constants/okr/okrDetails.constants';
import AddITemModal from '../components/modals/addItemModal';
import { getAiTypeActionLabel } from '../board/utils';
import { t } from 'i18next';
import { KR_TYPES, krdetailConstants } from '../constants/krdetails.constants';

/**
 * @mixins WbUniqueIdMixin
 * generate a uniue id.
 */
let wbUniqueId = 0;
export const WbUniqueIdMixin = {
	getUniueId() {
		return ++wbUniqueId;
	},
	uniqueId(prefix) {
		return prefix + this.getUniueId();
	},
	randomId(prefix) {
		const randomString = Math.random()
			.toString(36)
			.slice(2, 12);
		return prefix ? `${prefix}_${randomString}` : randomString;
	}
};

const getLocationContext = () => {
	const searchParams = new URLSearchParams(window.location.search);
	const refSrc = searchParams.get('location');
	return refSrc;
};

export const RelationshipMapTypes = {
	STRATEGY: 'strategy',
	PILLAR: 'pillar',
	OBJECTIVE: 'objective',
	KEYRESULT: 'keyresult',
	ACTION: 'action',
	WORKSTREAM: 'workstream',
	OUTCOME: 'outcome',
	JIRA: 'jira',
	LINK: 'link',
};

/**
 * @mixins WbEventHandlerMixinswb-meeting.scss
 * event handler
 */

export const WbEventHandlerMixins = {
	meetingPage(item) {
		return gotoMeetingPage(item.id);
	},
	goalPage(item) {
		const params = {};
		params.id = item.id;
		return viewGoalDetailsPage(undefined, params);
	},
	workstreamPage(item) {
		return window.open(
			`${wbConfig.baseUrl}/activity/workstreams?id=${item.id}`,
			"_blank"
		);
	},
	goalMetricPage(item, krdetails, ref = '', newWindow) {
		console.log('common js ref->', ref);
		var krdetail = krdetails ? krdetails : '';
		const params = {};
		console.log('common js goalMetricPage->', item);
		params.id = item.goal_id;
		params.metricId = item.id;
		if ((typeof item.hotboxType != "undefined" && item.hotboxType == "red_metrics") || krdetail != '') {
			return metricDetailsPage(item.id, ref, newWindow);
		}
		if (typeof params.id !== "undefined" && params.id !== null) {
			return viewGoalDetailsPage(undefined, params);
		}
		return viewCascadeMetric(params.metricId);
	},
	teamMemberPage(item) {
		$("#topBarOrgList").hide();
		const memberUrl = `${wbConfig.baseUrl}/workboard/actionItemList?uid=${item.userId}&type=team_members_work&tid=0&mystaff=1`;
		try {
			ajaxPageLoad(
				memberUrl,
				undefined,
				undefined,
				undefined,
				undefined,
				() => {
					highlightLeftMenu("menu-wb-myteam");
					$(".peekMenu").hide();
				}
			);
			if (typeof history.pushState !== "undefined") {
				const pushUrl = `${wbConfig.baseUrl}/team/teams?memberId=${item.userId}`;
				window.history.pushState({ urlPath: pushUrl }, "", pushUrl);
			}
			stateCount++;
		} catch (err) { }
	},
	relationshipMapPage (type, id, location) {
		if (typeof type !== 'undefined'
			&& typeof id !== 'undefined') {
			const url = `${wbConfig.baseUrl}/okrs/sem/${type}/${id}`;
			location = location.toUpperCase();
			type = type.toUpperCase();
			window.wb_track('RELATIONSHIP', {
				location,
				object: type == 'KEYRESULT' ? 'KEY_RESULT' : type,
				objectAction: 'VIEW_RM',
				objectId: id,
			});

			window.open(url, '_blank');
		}
	},

	/**
	 * ping goal to user.
	 */
	pingGoal(item) {
		let fullName;
		if (item.owner_fullname) {
			fullName = item.owner_fullname;
		} else if (item.firstname) {
			fullName = item.lastname ? item.firstname + ' ' + item.lastname : item.firstname;
		} else {
			fullName = 'The owner';
		}
		window.wb_track('OKR_ACTION', {
			location: getLocationContext(),
			locationDetail: 'Objectives_I_Own',
			object: 'OBJECTIVE',
			objectId: item.id,
			teamId: item.teamId,
			objectAction: 'PING',
			objectActionDetail: 'KEBAB_MENU',
		});
		$.post(
			`${wbConfig.baseUrl}/goal/sendGoalPingNotification`,
			{ goalId: item.id },
			() => {
				$("#mywobo-goals-wrapper .wspopupmenu-wrapper").hide();
				metricPingStatus(fullName, "goal");
			}
		);
	},
	/**
	 * copygoal.
	 */
	copyGoal(item) {
		// console.log(item, 'copyGoal');
		window.wb_track('OKR_ACTION', {
			location: getLocationContext(),
			locationDetail: 'Objectives_I_Own',
			object: 'OBJECTIVE',
			objectId: item.id,
			teamId: item.teamId,
			objectAction: 'COPY_AND_RESET_OKR',
			objectActionDetail: 'KEBAB_MENU',
		});
		copyGoal(item.id, item.refSrc, item.refType);
	},

	addRbrGoal(item) {
		if (
			typeof item.goalId !== "undefined" &&
			typeof item.userId !== "undefined"
		) {
			$.ajax({
				url: `${wbConfig.baseUrl}/rbr/addRbrGoal`,
				type: "GET",
				data: { goalId: item.goalId, userId: item.userId }
			})
				.done(response => {
					$(
						`.teamgoals-row .wspopupmenu-wrapper[data-id="${item.goalId}"]`
					).hide();
					if (response.status == "success") {
						let objectiveTitle = localeJsonValue['Objective'] ? localeJsonValue['Objective'] : 'Objective';
						toastr.success(`${objectiveTitle} was added to the RBR page.`);
					}
				})
				.fail(response => {
					$(
						`.teamgoals-row .wspopupmenu-wrapper[data-id="${item.goalId}"]`
					).hide();
					alert(t("Please try again later."));
				});
		}
	},

	editGoal(item, fromPage, addKr = false) {
		const myGoal = item.type == 2 ? "1" : "0";
		const tid = item.teamId || item.team_id || 0;
		const gid = item.id;
		const metricTeamOpen = `team-goal-${gid}`;
		const src = typeof item.src !== "undefined" ? item.src : null;
		window.wb_track('OKR_ACTION', {
			location: getLocationContext(),
			locationDetail: 'Objectives_I_Own',
			object: 'OBJECTIVE',
			objectId: gid,
			teamId: tid,
			objectAction: 'EDIT',
			objectActionDetail: 'KEBAB_MENU',
		});
		openEditGoalPopup(myGoal, undefined, tid, gid, metricTeamOpen, undefined, src, fromPage, addKr);
	},

	delGoal(item) {
		const tid = item.teamId || item.team_id || undefined;
		window.wb_track('OKR_ACTION', {
			location: getLocationContext(),
			locationDetail: 'Objectives_I_Own',
			object: 'OBJECTIVE',
			objectId: item.id,
			teamId: tid,
			objectAction: 'DELETE',
			objectActionDetail: 'KEBAB_MENU',
		});
		goal_delet_confirm
			.data("goalId", item.id)
			.data("enable", 1)
			.dialogOpen();
	},

	closeGoal(item, copyBeforeClose = false, refSrc, refType) {
		const tid = item.teamId || item.team_id || undefined;
		window.wb_track('OKR_ACTION', {
			location: getLocationContext(),
			locationDetail: 'Objectives_I_Own',
			object: 'OBJECTIVE',
			objectId: item.id,
			teamId: tid,
			objectAction: 'CLOSE_OUT_OKR',
			objectActionDetail: 'KEBAB_MENU',
		});
		closeGoal(item.id, copyBeforeClose, refSrc, refType);
	},

	/**
	 * Give a badge from the My OKRs page.
	 */
	goalBadgeMyOkr(item) {
		WbEventHandlerMixins.goalBadge(item, 'MY_OKRS');
	},

	/**
	 * give badge.
	 */
	goalBadge(item, analyticName = null) {
		// console.log(item, 'goalBadge');
		sendBadgeFun(item?.teamId, item?.owner, undefined, item?.id, item?.id, undefined, undefined, analyticName);
	},

	goalRequestFeedback(item, analyticName = null) {
		openRequestFeedbackModal({
			teamId: item?.teamId,
			ownerId: item?.owner,
			goalId: item.id,
			analyticName
		});
	},

	metricBadge (item, analyticName = null) {
		sendBadgeFun(item.teamId, item.owner, undefined, item.goal.id, item.goal.id, undefined, item.metric.id, analyticName);
	},

	metricRequestFeedback(item, analyticName = null) {
		openRequestFeedbackModal({
			teamId: item.teamId,
			ownerId: item.owner,
			goalId: item.goal.id,
			metricId: item.metric.id,
			analyticName
		});
	},

	reopenOkr(item) {
		goal_reopen_confirm.data("goalId", item.id).dialogOpen();
	},

	/**
	 * meetingAgenda
	 */
	meetingAgenda(item) {
		// console.log(item, 'meetingAgenda');
		if (typeof item.menu_type !== "undefined" && item.menu_type == "ws") {
			sendTeamAgenda(undefined, undefined, undefined, undefined, item.id);
		} else if (typeof item.menu_type !== "undefined" && item.menu_type == "kr") {
			sendTeamAgenda(undefined, undefined, undefined, undefined, undefined, item.id);
		} else if (typeof item.hotboxType !== "undefined" && ( item.hotboxType == "red_goal" || item.hotboxType == "amber_goal" ) ) {
			sendTeamAgenda(item.teamId, item.goalOwner, undefined, item.id);
		} else if (typeof item.hotboxType !== "undefined" && (item.hotboxType == "red_metrics" || item.hotboxType == 'metrics')) {
			sendTeamAgenda(undefined, undefined, undefined, undefined, undefined, item.id);
		} else if (typeof item.hotboxType !== "undefined" && item.hotboxType == "red_ws") {
			sendTeamAgenda(undefined, undefined, undefined, undefined, item.id);
		} else if (typeof item.hotboxType !== "undefined" && ( item.hotboxType == "red_ai" || item.hotboxType == 'ai') ) {
			sendTeamAgenda(undefined, undefined, item.id);
		}else {
			sendTeamAgenda(item.teamId, item.goalOwner, undefined, item.id);
		}

		window.wb_track('OKR_ACTION', {
			location: getLocationContext(),
			locationDetail: 'Objectives_I_Own',
			object: 'OBJECTIVE',
			objectId: item.id,
			teamId: item.teamId,
			objectAction: 'ADD_TO_MEETING',
			objectActionDetail: 'KEBAB_MENU',
		});
	},
	/**
	 * oneOnOneAgenda
	 */
	oneOnOneAgenda(item) {
		// console.log(item, 'oneOnOneAgenda');
		if (typeof item.menu_type !== "undefined" && item.menu_type == "ws") {
			send1on1Agenda(undefined, item.rbrOwner, undefined, undefined, item.id);
		} else if (typeof item.menu_type !== "undefined" && item.menu_type == "kr") {
			send1on1Agenda(undefined, undefined, undefined, undefined, undefined, item.id);
		} else if (typeof item.hotboxType !== "undefined" && ( item.hotboxType == "red_goal" || item.hotboxType == "amber_goal" ) ) {
			send1on1Agenda(item.teamId, item.goalOwner, undefined, item.id);
		} else if (typeof item.hotboxType !== "undefined" && (item.hotboxType == "red_metrics" || item.hotboxType == 'metrics')) {
			send1on1Agenda(undefined, undefined, undefined, undefined, undefined, item.id);
		} else if (typeof item.hotboxType !== "undefined" && item.hotboxType == "red_ws") {
			send1on1Agenda(undefined, undefined, undefined, undefined, item.id);
		} else if (typeof item.hotboxType !== "undefined" && ( item.hotboxType == "red_ai" || item.hotboxType == 'ai') ) {
			send1on1Agenda(undefined, undefined, item.id);
		} else {
			send1on1Agenda(item.teamId, item.goalOwner, undefined, item.id);
		}

		window.wb_track('OKR_ACTION', {
			location: getLocationContext(),
			locationDetail: 'Objectives_I_Own',
			object: 'OBJECTIVE',
			objectId: item.id,
			teamId: item.teamId,
			objectAction: 'ADD_TO_1ON1',
			objectActionDetail: 'KEBAB_MENU',
		});
	},
	getPrioText(prio) {
		let priorityValue;
		if (prio == 3) {
			priorityValue = "Normal";
		} else if (prio == 1) {
			priorityValue = "Highest";
		} else if (prio == 2) {
			priorityValue = "High";
		}
		return priorityValue;
	},
	getStatusText(state) {
		let statusValue;
		if (state == 0) {
			statusValue = "Done";
		} else if (state == 1) {
			statusValue = "Doing";
		} else if (state == 2) {
			statusValue = "Next";
		} else if (state == 4) {
			statusValue = "Pending";
		}
		return statusValue;
	},
	getStateText(stateType) {
		let statusValue;
		if (stateType == "1") {
			statusValue = "doing";
		} else if (stateType == "0") {
			statusValue = "done";
		} else if (stateType == "4") {
			statusValue = "pause";
		} else if (stateType == "2") {
			statusValue = "next";
		}
		return statusValue;
	},
	getTypeText(state) {
		let statusValue;
		if (state == 0) {
			statusValue = "done";
		} else if (state == 1) {
			statusValue = "doing";
		} else if (state == 2) {
			statusValue = "next";
		} else if (state == 4) {
			statusValue = "pause";
		}
		return statusValue;
	},
	getEffortText(effort) {
		let effValue;
		if (effort == 1) {
			effValue = "Easy";
		} else if (effort == 2) {
			effValue = "Medium";
		} else if (effort == 3) {
			effValue = "Huge";
		}
		return effValue;
	},
	getRagText(rag) {
		let ragValue;
		if (rag == 0) {
			ragValue = "Green";
		} else if (rag == 1) {
			ragValue = "Amber";
		} else if (rag == 2) {
			ragValue = "Red";
		}
		return ragValue;
	},
	getTempAi(userDet, curDate, desc, tempId, state, type) {
		const tempAiArr = {};
		tempAiArr.id = tempId;
		tempAiArr.description = desc;
		tempAiArr.priority = 3;
		tempAiArr.owner_firstname = userDet.firstname;
		tempAiArr.owner_lastname = userDet.lastname;
		tempAiArr.dueDateText = curDate;
		tempAiArr.rag = 0;
		tempAiArr.commentCount = 0;
		tempAiArr.attachCount = 0;
		tempAiArr.tagCount = 0;
		tempAiArr.subCount = {
			doneCount: null,
			totalCount: "0"
		},
		tempAiArr.loopCount = 0;
		tempAiArr.full_access = 0;
		tempAiArr.state = state;
		tempAiArr.aiTags = [];

		if (type == "subAi") {
			tempAiArr.desc = desc;
			tempAiArr.due_date_text = curDate.split(",")[0];
			tempAiArr.ownerName = `${userDet.firstname} ${userDet.lastname.substr(0,1)} .`
		}
		return tempAiArr;
	},
	getTempCommentArr(commentVal, commDate, userDet, tempCommId, aiId) {
		const tempComArr = [];
		tempComArr.id = tempCommId;
		tempComArr.comment = commentVal;
		tempComArr.owner = userDet.id;
		tempComArr.act_id = aiId;
		tempComArr.firstname = userDet.firstname;
		tempComArr.lastname = userDet.lastname;
		tempComArr.ownerImage = userDet.picture;
		tempComArr.create_at_text = commDate;
		return tempComArr;
	},
	unSafeHtml(str) {
		if (str == "" || str == null || typeof str === "undefined") return str;
		str = str.replace(new RegExp("&#39;", "g"), "'");
		str = str.replace(new RegExp("&#039;", "g"), "'");
		str = str.replace(/<[^>]*>/g, ""); // strip html tags
		return escapeHtml(str);
	},
	descAutoHeight(textarea, adjustHeight = 0) {
		$(textarea)
			.each(function () {
				$(this)
					.css({ height: "auto", "overflow-y": "hidden" })
					.height(this.scrollHeight - adjustHeight);
			})
			.on("input", function () {
				$(this)
					.css({ height: "auto", "overflow-y": "hidden" })
					.height(this.scrollHeight - adjustHeight);
			});
	},
	nl2br(str) {
		if (!str || str == "") {
			return "";
		}
		const breakTag = "<br />";
		const newCont = String(str).replace(
			/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
			`$1${breakTag}$2`
		);
		return newCont;
	},
	openMetricUpdatePopup(metricId, parentMId, ref = '') {
		return openEditMetricData(
			metricId,
			metricId,
			undefined,
			undefined,
			parentMId,
			ref
		);
	},
	replaceTxtNotInA(html, regex, replace) {
		html = `>${html}<`;
		html = html.replace(
			/>([^<>]+)(?!<\/a)</g,
			(match, txt) => `>${txt.replace(regex, replace)}<`
		);
		return html.substring(1, html.length - 1);
	},
	replaceLinkWithAnchor(textValue) {
		if (typeof textValue === "undefined" || textValue.length == 0) {
			return textValue;
		}
		let html = textValue;
		const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&amp;&@#\/%?=~_|!:,.;]*[-A-Z0-9+&amp;&@#\/%=~_|])/gi;
		html = WbEventHandlerMixins.replaceTxtNotInA(
			html,
			exp,
			"<a href='$1' target='_blank'>$1</a>"
		);
		const exp2 = /\b(www\.[\S]+)\b/gi;
		html = WbEventHandlerMixins.replaceTxtNotInA(
			html,
			exp2,
			'<a href="http://$1" target="_blank">$1</a>'
		);
		return html;
	},
	aiDetailPage(aiId, obj, viewAccess) {
		if (viewAccess == "false") {
			return;
		}
		const urlVal = `${wbConfig.baseUrl}/activity/aI?id=${aiId}`;
		if (urlVal && aiId && obj) {
			/* if(typeof getAppContext !== 'undefined' && getAppContext() == 'msteams'){
							urlVal = wbConfig.baseUrl + '/activity/mywork?do=popup&id='+ aiId;
							return window.open(urlVal, 'openai');
						} */
			return openFullPopUp(aiFullViewPopUp, urlVal, $(obj));
		}
	},
	firstCharUppercase(string = "") {
		let s = "";
		if (typeof string === "string") {
			s = string.charAt(0).toUpperCase() + string.substring(1, string.length);
		}
		return s;
	},
	onlyFirstUpperText(string = "") {
		const s = "";
		if (typeof string === "string") {
			return string.charAt(0).toUpperCase();
		}
		return s;
	},
	buildCommentString(comment = {}, show_date = false, offset = 0) {
		let commentString = "";
		if (typeof comment !== "undefined" && Object.keys(comment).length) {
			const firstname = this.firstCharUppercase(comment.firstname);
			const lastname = comment.lastname;
			commentString = `${firstname} ${lastname}:`;
			let dateDisplay = "";
			if (show_date) {
				const dateFormat = this.getDateFormatInUserTimezone(
					comment.create_at,
					offset
				);
				dateDisplay = `<span class="rbr-comment-date"> ${dateFormat}</span>`;
			}
			if (typeof comment.metric !== "undefined" && comment.metric.id) {
				commentString += ` ${comment.comment}`;
				let { m_data } = comment.metric;
				if (comment.metric.counting == RbrConst.METRIC_COUNTING_SURVEY_YES_NO) {
					if (comment.metric.m_data == "1") {
						m_data = "No";
					} else if (comment.metric.m_data == "2") {
						m_data = "Yes";
					}
				}
				if (m_data != "" && m_data != null) {
					commentString += `<span style="font-weight: normal;"> - Updated ${comment.metric.name} to ${m_data} </span>`;
				}
				commentString += ` ${dateDisplay}`;
			} else {
				commentString += ` ${dateDisplay} ${comment.comment}`;
			}
		}
		return commentString;
	},
	buildRBRCommentString(comment = {}, show_date = false, offset = 0) {
		let commentString = "";
		if (typeof comment !== "undefined" && Object.keys(comment).length) {
			const firstname = this.firstCharUppercase(comment.firstname);
			const lastname = comment.lastname;
			commentString = `<span class="rbr-comment-ownername">${firstname} ${lastname}</span>`;
			let dateDisplay = "";
			if (show_date) {
				const dateFormat = this.getDateFormatInUserTimezone(
					comment.create_at,
					offset
				);
				dateDisplay = `<span class="dotClass"></span><span class="rbr-comment-date"> ${dateFormat}</span>`;
			}
			if (typeof comment.metric !== "undefined" && comment.metric.id) {
				let { m_data } = comment.metric;
				if (comment.metric.counting == RbrConst.METRIC_COUNTING_SURVEY_YES_NO) {
					if (comment.metric.m_data == "1") {
						m_data = "No";
					} else if (comment.metric.m_data == "2") {
						m_data = "Yes";
					}
				}
				if (m_data != "" && m_data != null) {
					commentString += `<span class="dotClass"></span><span style="font-weight: normal;">Updated to ${m_data} </span>`;
				}
			}
			commentString += ` ${dateDisplay}`;
		}
		return commentString;
	},
	buildRBRConfidenceString(confidence = {}, show_date = false, offset = 0) {
		let commentString = "";
		if (typeof confidence !== "undefined" && Object.keys(confidence).length) {
			const name = this.firstCharUppercase(confidence.added_by_name);
			commentString = `<span class="rbr-comment-ownername">${name}</span>`;
			let dateDisplay = "";
			if (show_date) {
				dateDisplay = `<span class="dotClass"></span><span class="rbr-comment-date"> ${confidence.created_at_formatted}</span>`;
			}
			commentString += ` ${dateDisplay}`;
			if (typeof confidence.confidence != 0) {

					commentString += `<span class="dotClass"></span><span style="font-weight: normal;"> ${confidence.confidenceLabel} </span>`;

			}
		}
		return commentString;
	},
	sortingItems(items = [], sortingArray = [], type = "", groupType = "") {
		let sorting_items = [];
		if (Array.isArray(sortingArray) && sortingArray.length > 0) {
			sortingArray.map(s => {
				if (type == "hotbox") {
					if (typeof s === "object") {
						const findS = items.find(
							i => i.id == s.id && i.hotboxType == s.hotboxType
						);
						if (findS) {
							sorting_items = sorting_items.concat(findS);
						}
					}
				} else if (type == "charts" || type.indexOf("rbr_groups_") > -1) {
					let findS2 = "";
					if (groupType == "1") {
						findS2 = items.find(i => `${i.type}_${i.id}` == s);
					} else {
						findS2 = items.find(i => i.id == s);
					}
					if (findS2) {
						sorting_items = sorting_items.concat(findS2);
					}
				} else {
					const findS1 = items.find(i => i.id == s);
					if (findS1) {
						sorting_items = sorting_items.concat(findS1);
					}
				}
			});
			let remainingItems = [];
			if (type == "hotbox") {
				let sortingArrayIds = sortingArray.map(s =>
					typeof s === "object" ? s.id : null
				);
				sortingArrayIds = sortingArrayIds.filter(i => i !== null);
				remainingItems = items.filter(
					item => !sortingArrayIds.includes(item.id)
				);
				// remainingItems = items.filter(i => sortingArray.some(s => typeof s === 'object' && !(s.id == i.id && s.hotboxType == i.hotboxType)));
			} else if (type == "charts" || type.indexOf("rbr_groups_") > -1) {
				if (groupType == "1") {
					remainingItems = items.filter(
						i => sortingArray.indexOf(`${i.type}_${i.id}`) === -1
					);
				} else {
					remainingItems = items.filter(i => sortingArray.indexOf(i.id) === -1);
				}
			} else {
				remainingItems = items.filter(i => sortingArray.indexOf(i.id) === -1);
			}
			return sorting_items.concat(remainingItems);
		}

		return items;
	},
	getDateFormatInUserTimezone(dateTime, offset = 0, format = "") {
		if (dateTime == "" || dateTime == null || dateTime == "undefined") {
			return "";
		}
		if (format == "" || format == "undefined" || format == null) {
			format = "MMM DD, YYYY";
		}
		dateTime = parseInt(dateTime);
		if (typeof offset !== "undefined") {
			if (offset != null && offset != "") {
				dateTime += offset;
			}
		}
		// console.log(`getDateFormatInUserTimezone --> ${dateTime} ${format} `);
		return moment.utc(dateTime * 1000).format(format);
	},
	isMacOs() {
		return !!navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i);
	},
	placeCaretAtEnd(el) {
		if (el && typeof el !== "undefined") {
			$(el).trigger("focus");
			if (
				typeof window.getSelection !== "undefined" &&
				typeof document.createRange !== "undefined"
			) {
				const range = document.createRange();
				range.selectNodeContents(el);
				range.collapse(false);
				const sel = window.getSelection();
				sel.removeAllRanges();
				sel.addRange(range);
			} else if (typeof document.body.createTextRange !== "undefined") {
				const textRange = document.body.createTextRange();
				textRange.moveToElementText(el);
				textRange.collapse(false);
				textRange.select();
			}
		}
	},
	getTempFt(desc, tempId) {
		const tempFtArr = [];

		tempFtArr.id = tempId;
		tempFtArr.description = desc;
		tempFtArr.status = 1;

		return tempFtArr;
	},
	getKrType(metricSource, metricType, extAppId = null) {
		
		let krType = "person";
		if (typeof KR_TYPES[metricSource] !== 'undefined') {
			if ((metricSource == "1" || metricSource == "3") && metricType == "2") {
				krType = KR_TYPES[9];
			} else if (extAppId && extAppId == "15" && metricSource == "8") {
				krType = KR_TYPES[extAppId];
			} else {
				krType = KR_TYPES[metricSource];
			}
		}
		return krType;
	},
	getInverseKrType(krTypeNumber) {
		for (const [key, value] of Object.entries(KR_TYPES)) {
			if (value === krTypeNumber) {
				return parseInt(key);
			}
		}
		return null;
	},
	pinGoal(obj_type,resp,updateStatus,obj_id) {
		upDateFavorites(obj_type, resp, updateStatus);
		updateLeftMenuData(obj_type, obj_id, obj_type, "pin", {
			status: updateStatus,
			pinData: resp
		});
	}
};

/**
 * Sanitizes data with dompurify library
 * @param {String} content
 * @returns
 */
export const sanitize = function (content) {
	const sanitizer = dompurify.sanitize;
	// DOMPurify removes event handlers by default, so we don't need FORBID_ATTR
	return sanitizer(content, { 
		ADD_ATTR: ['target', 'data-user-id', 'src', 'data-testid'],
		// Explicitly allow only safe protocols: https, http, blob:, and relative URLs
		ALLOWED_URI_REGEXP: /^(?:(?:https?|blob):|(?:\/|#|\.|\?))/i
	});
};

/**
 * html markdown
 * use Reactjs dangerouslySetInnerHTML
 */
export const WbMarkdownHtml = function (content, sanitizeContent = false) {
	if (sanitizeContent) {
		content = sanitize(content);
	}
	return { __html: content };
};

/**
 * Go to meeting page.
 */
var gotoMeetingPage = function (id) {
	const url = `${wbConfig.baseUrl}/meeting/meetingDetails?id=${id}`;
	window.open(url, "openmeeting");
	return false;
};

/**
 *  This method is used to get an image path.
 */
export const IconPathComp = function (id) {
	const imgPath = {
		doing: "images/icons/doing_blue.png",
		red: "images/rbr/red@2x.png",
		amber: "images/rbr/amber@2x.png",
		green: "images/Priorities/green.png",
		late: "images/rbr/late@2x.png",
		add: "images/icons/dropdowns/add.png",
		add_gray: "images/icons/dropdowns/add_gray_b.png",
		close: "images/icons/close_x.png",
		close_image: "images/icons/del_gray.png",
		goal: "images/rbr/goals@2x.png",
		metric: "images/rbr/metrics@2x.png",
		red_1on1_epa: "images/rbr/member@2x.png",
		ai: "images/rbr/action_items@2x.png",
		today_empty: "images/rbr/today_empty.png",
		metrics_empty: "images/rbr/metrics_empty.png",
		goals_empty: "images/rbr/goals_empty.png",
		ws_empty: "images/rbr/ws_empty.png",
		hotbox_empty: "images/rbr/hotbox_empty.png",
		blue_additem: "images/rbr/blue_additem.png",
		ws_grey: "images/rbr/ws@2x.png",
		loadinggif: "images/icons/loading.gif",
		priority_highest: "images/Priorities/top_priority.png",
		priority_high: "images/Priorities/medium.png",
		priority_normal: "images/icons/low_priority_tables_3x.png",
		removefromtray_img: "images/icons/dropdowns/close@3x.png",
		clock_img: "/images/mywork/clock@3x.png",
		clock_svg: "/images/mywork/clock.svg",
		ping_svg: "/images/mywork/ping.svg",
		confidence_svg: "/images/mywork/confidence.svg",
		edit_img: "images/obj_dropdown/edit_settings.png",
		edit_image: "images/icons/edit_gray_s.png",
		edit_gray_image: "images/shared_RBR/edit_grey@3x.png",
		delete_img: "/images/obj_dropdown/delete_okr.png",
		closegoal_img: "/images/obj_dropdown/close_okr.png",
		copy_img: "/images/obj_dropdown/copy_okr.png",
		ping_img: "/images/obj_dropdown/ping_for_update.png",
		badge_img: "/images/icons/dropdowns/give_feedback.svg",
		addtomeet_img: "/images/icons/dropdowns/meeting@3x.png",
		addto1on1_img: "/images/obj_dropdown/add_1on1_agenda.png",
		update_img: "/images/obj_dropdown/update.png",
		print_img: "/images/icons/dropdowns/print.png",
		resultshist_img: "/images/obj_dropdown/results_history.png",
		personalize_img: "/images/icons/menu/settings_menu.png",
		share_img: "/images/share-img-icon.png",
		dummyOwnerImg: "/images/profile/LetterImages/Letters_A.png",
		addAiPlus: "/images/icons/board/add_grey.png",
		addAttach: "/images/icons/add_attachement.png",
		full_det_img: "/images/icons/board/full_details.png",
		publish_img: "/images/icons/drop/publish.png",
		publish_img_board: "/images/icons/dropdowns/publish@3x.png",
		permissions_img: "images/icons/dropdowns/permissions.png",
		move_img: "images/icons/dropdowns/shuffle@3x.png",
		close_img: "images/icons/dropdowns/close@3x.png",
		rbr_add_img: "images/icons/dropdowns/add_to_biz_grey@3x.png",
		integration_img: "images/icons/dropdowns/pushtointegration.png",
		reopen_img: "images/icons/dropdowns/reopen.png",
		archive_img: "images/icons/dropdowns/archive@3x.png",
		move_backlog_img: "images/icons/board/backlog.png",
		subact_img: "images/icons/board/subActImg.png",
		metric_upd_img: "images/icons/metricUpdate.png",
		metric_upd_img_new: "images/icons/update_krs.png",
		emoticon_img: "images/goal/emoticon/50.png",
		emoticon_new_img: "images/goal/new_emoji_icon.png",
		expand_img: "images/icons/expand.png",
		details_blue: "images/goal/details_blue.png",
		details_grey: "images/goal/details_grey.png",
		help_img: "images/goal/help_small.png",
		arrow_down_blue: "images/icons/arrow_down_blue.png",
		arrow_up_blue: "images/icons/arrow_up_blue.png",
		themes: "images/icons/dropdowns/themes@3x.png",
		user_permissions: "images/icons/dropdowns/user profile@3x.png",
		add_to: "images/icons/dropdowns/add@3x.png",
		manage_lifecycle: "images/icons/dropdowns/workstream@3x.png",
		add_column: "images/icons/add_column@2x.png",
		board_timeLine: "images/icons/board/timeline.png",
		narrative: "images/icons/board/narrative.png",
		date_grey: "images/icons/date_grey.png",
		arrow_down_gray: "images/icons/down-arrow.png",
		arrow_up_gray: "images/icons/up_arrow.png",
		subactions_inactive: "images/ai-v1-assets/subactions_inactive.png",
		close_topic_take: "images/ai-v1-assets/x@2x.png",
		artboard: "images//icons/kebab_new.png",
		recurring: "images/Priorities/recurring.png",
		remindme: "images/icons/dropdowns/remindme.png",
		badge: "images/icons/dropdowns/badge.png",
		publish_meeting: "images/icons/dropdowns/publish@3x.png",
		meetings_grey: "images/icons/dropdowns/meeting@3x.png",
		decision: "images/meeting_assets/decision.png",
		past_meeting: "images/icons/dropdowns/past_grey@3x.png",
		close_meeting: "images/icons/dropdowns/delete@3x.png",
		edit_meeting: "images/icons/dropdowns/edit_grey@3x.png",
		view_meeting: "images/icons/main_menu/search.png",
		up_meeting: "images/meeting_assets/ic/chevron/small/down/grey.png",
		down_meeting: "images/meeting_assets/ic/chevron/small/up/grey_copy.png",
		decision_send: "images/loadimages/decision.png",
		ai_gray: "images/meeting_assets/ai_grey.png",
		delete_topic: "images/ai-v1-assets/delete.png",
		ping: "images/icons/dropdowns/ping@3x.png",
		userImage: "images/wb.png",
		rbrPplImage: "images/header_assets/contributors.png",
		rbrDownArrow: "images/arrow.png",
		rbrUpArrow: "images/arrow_up.png",
		objImage: "images/meeting_assets/OKR_blue@3x.png",
		keyRImage: "images/meeting_assets/KR_blue@3x.png",
		wsImage: "images/meeting_assets/ws_blue@3x.png",
		actionImage: "images/meeting_assets/ai_blue@3x.png",
		ai_effort_high: "images/icons/action_items/effort_high.svg",
		ai_priority_high: "images/icons/action_items/priority_high.svg",
		ai_priority_highest: "images/icons/action_items/priority_highest.svg",
		ai_priority_normal: "images/icons/action_items/priority_normal.svg",
		ai_rag_amber: "images/icons/action_items/RAG_Amber.svg",
		ai_rag_green: "images/icons/action_items/RAG_Green.svg",
		ai_rag_red: "images/icons/action_items/RAG_Red.svg",
		ai_state_next: "images/icons/action_items/progress_next.svg",
		ai_state_doing: "images/icons/action_items/progress_doing.svg",
		ai_state_done: "images/icons/action_items/progress_done.svg",
		ai_state_pause: "images/icons/action_items/progress_pause.svg",
		asana: "images/icons/asana3x.png",
		jira: "images/icons/jira3x.png",
		github: "images/icons/git3x.png",
		// high : 'images/shared_RBR/high.png',
		// medium : 'images/shared_RBR/medium.png',
		action_items_empty: "images/shared_RBR/action_items_empty.png",
		share_rbr: "images/icons/dropdowns/share@3x.png",
		logout_pic: "images/icons/settings/logout_pic.png",
		workboard: "images/icons/img5_wb.png",
		workboard_gray: "images/icons/wb.png",
		next: "images/icons/thisWeek/next.png",
		rbrPvtImage: "images/shared_RBR/lock@3x.png",
		rbr_shared_icon: "images/shared_RBR/members@3x.png",
		rbr_org_icon: "images/shared_RBR/org_rbr.png",
		next_state: "images/icons/thisWeek/next.png",
		done_state: "images/icons/thisWeek/done.png",
		doing_state: "images/icons/thisWeek/doing.png",
		pause_state: "images/icons/thisWeek/pause.png",
		arrow_new: "images/arrow_new.png",
		medium: "images/ai-v1-assets/highpri_active.png",
		high: "images/ai-v1-assets/highestpri_active.png",
		fileAttch: "images/meeting_assets/file_grey@3x.png",
		bar_chart: "images/shared_RBR/bar_chart.svg",
		line_chart: "images/shared_RBR/line_chart.svg",
		tabular_chart: "images/shared_RBR/table_chart.svg",
		stacked_bar_chart: "images/shared_RBR/stacked_bar_chart.svg",
		donut_chart: "images/shared_RBR/donut_chart.svg",
		planned_chart_bar: "images/shared_RBR/target_bar_chart.svg",
		planned_chart_line: "images/shared_RBR/target_line_chart.svg",
		add_chart: "images/shared_RBR/add_chart@3x.png",
		calendar: "images/wizard_Assets/calendar@3x.png",
		convert_to_subaction: "images/icons/dropdowns/subactions@3x.png",
		convert_to_action: "images/icons/dropdowns/action_items@3x.png",
		cal_arrow_down: "images/arrow.png",
		ws_sync: "images/icons/sync_ws.png",
		board_empty: "images/icons/board/board_empty.png",
		delete_gray: "images/delete_gray.png",
		delete_image: "images/goal/delete_new.png",
		delete_image3X: "images/goal/delete@3x.png",
		automation: "images/icons/board/automation.png",
		open_ws: "images/icons/open_ws@3x.png",
		automation_img: "images/icons/board/automation_grey.png",
		favImg: "images/icons/main_menu/add/favorites@3x.png",
		timmarshal: "images/icons/board/tim-marshall-57456.jpg",
		johnsalzarulo: "images/icons/board/john-salzarulo.jpg",
		jeremythomas: "images/icons/board/jeremy-thomas.jpg",
		iandooley: "images/icons/board/ian-dooley.jpg",
		favoriteImg: "/images/icons/main_menu/add/favorites@3x.png",
		recentImg: "/images/icons/main_menu/add/recents@3x.png",
		boardImg: "/images/icons/main_menu/add/fill.png",
		aiImage: "/images/meeting_assets/ic/action_item.png",
		linkToBox: "/images/meeting_assets/link/box.png",
		linkToDropBox: "/images/meeting_assets/link/dropbox.png",
		linkToOneDrive: "/images/meeting_assets/link/onedrive.png",
		linkToGoogleDrive: "/images/meeting_assets/link/google.png",
		recurringTemp: "/images/meeting_assets/recurring.png",
		addToFav: "/images/meeting_assets/pin/grey@3x.png",
		delFromFav: "/images/meeting_assets/pin/blue@3x.png",
		text_images: "/images/boards/text_images@3x.png",
		board_ws: "/images/boards/ws@3x.png",
		board_people: "/images/boards/people@3x.png",
		kebab_menu: "images/ai-v1-assets/kebab_aiwindow@2x.png",
		ws_attributes: "images/icons/dropdowns/ws_attributes.png",
		linkToYourComputer: "/images/meeting_assets/link/computer.png",
		linkToLink: "/images/meeting_assets/link/link.png",
		removeWsImg: "/images/wizard_Assets/delete_x@3x.png",
		add_chart_group: "/images/icons/dropdowns/outline-show-chart-24-px@3x.png",
		publish_img_rbr: "/images/icons/dropdowns/publish_new@3x.png",
		add_kr_group: "/images/rbr/kr-group@3x.png",
		reload_button: "/images/workstreams/reload_button@3x.png",
		mapping_arrow: "/images/workstreams/mapping_arrow.png",
		delete_icon: "/images/rbr/outline-delete-24-px@3x.png",
		full_det_img2x: "/images/icons/board/full_details@2x.png",
		sync_now_24px: "/images/icons/menu/menuicons/syncnow.png",
		confidence_button_icon: "/images/icons/confidence/Confidence-Action.svg",
		confidence_Low: "/images/icons/confidence/Confidence-Low.png",
		confidence_Medium: "/images/icons/confidence/Confidence-Medium.png",
		confidence_High: "/images/icons/confidence/Confidence-High.png",
		kr_cluster_1x: "/images/icons/kr-cluster/icon-tip-lightbulb.png",
		kr_cluster_2x: "/images/icons/kr-cluster/icon-tip-lightbulb@2x.png",
		kr_cluster_3x: "/images/icons/kr-cluster/icon-tip-lightbulb@3x.png",
		hide_icon: "/images/icons/hide.png",
		new_metric: "/wobo-frontend/src/vectors/key-result.svg",
		empty_table: "/images/rbr/emptyTable.png",
		unHide_icon: "/images/icons/unHide.svg",
		editSvgIcon: "/images/icons/dropdowns/edit.svg",
		deleteSvgIcon: "/images/icons/dropdowns/delete.svg",
		delegateSvgIcon: "/images/icons/dropdowns/delegate.svg",
		copyLinkSvgIcon: "/images/icons/dropdowns/copy_link.svg",
		copySvgIcon: "/images/icons/dropdowns/copy.svg",
		closeOutSvgIcon: "/images/icons/dropdowns/closeout.svg",
		copyResetSvgIcon: "/images/icons/dropdowns/copy_reset.svg",
		addMeetingSvgIcon: "/images/icons/dropdowns/add_1on1meeting.svg",
		updateKrSvgIcon: "/images/icons/dropdowns/update_kr.svg",
		openOkrSvgIcon: "/images/icons/dropdowns/open_okr.svg",
		pingSvgIcon: "/images/icons/dropdowns/ping.svg",
		relationMapSvgIcon: "/images/icons/dropdowns/relation_map.svg",
		giveFeedbackSvgIcon: "/images/icons/dropdowns/give_feedback_new.svg",
		requestFeedbackSvgIcon: "/images/icons/dropdowns/request_feedback.svg",
		paceIcon: "/wobo-frontend/src/vectors/pace.svg",
	};
	return typeof imgPath[id] !== "undefined"
		? `${wbConfig.imageCdnUrl}/${imgPath[id]}`
		: "";
};

/**
 *  This method is used to save worstream import
 */
export const saveWsImport = function (
	importFrom,
	projectType,
	wsName,
	projectId,
	teamId,
	syncTask,
	ownerMap,
	repositoriesId,
	repositoriesIds,
	importId,
	jql,
	statusMap,
	instance_url,
	isJiraBasic = false
) {
	// console.log("call saveWsImport");
	if (wsName != "" && projectId != "") {
		let data;
		if (jql) {
			data = JSON.stringify({
				app: importFrom,
				type: projectType,
				wsName,
				projectId,
				teamId,
				syncTask,
				ownerMap,
				repositoriesId,
				repositoriesIds,
				importId,
				jql,
				statusMap,
				instance_url
			});
		} else if (isJiraBasic == true) {
			data = JSON.stringify({
				app: importFrom,
				type: projectType,
				wsName,
				projectId,
				teamId,
				syncTask,
				ownerMap,
				repositoriesId,
				repositoriesIds,
				importId,
				jql: "",
				statusMap,
				instance_url
			});
		} else {
			data = JSON.stringify({
				app: importFrom,
				type: projectType,
				wsName,
				projectId,
				teamId,
				syncTask,
				ownerMap,
				repositoriesId,
				repositoriesIds,
				importId,
				instance_url
			});
		}
		showLoaderWidget($("#content"));
		$.ajax({
			url: `${wbConfig.baseUrl}/integration/saveExtProjects`,
			type: "POST",
			data,
			dataType: "json",
			processData: false
		})
			.done(response => {
				// console.log(response)
				removeLoader();
				if (typeof response === "string") {
					response = response.trim();
				}
				if (response == "" || response.length == 0) {
					//  console.log("response if");
				} else if (response.data.error != "") {
					alert(response.data.error);
				} else {
					//  console.log(response.data.wsId);
					// let wsUrl = $('.workstreamMain').attr('wsUrl');
					renderWsLeftMenu();
					renderLeftMenu("teamPeek");
					const wsUrl = `${workstreamPageURL}?teamId=${teamId}&teamView`;
					triggerLeftMenu(wsUrl, false, "menu-wb-workstreams");
					$(window).scrollTop(0);
					wsSyncProgress.dialogOpen();
					setTimeout(() => {
						wsSyncProgress.dialog("close");
					}, 10000);
				}
			})
			.fail((jqXHR, textStatus) => {
				removeLoader();
				// console.log(jqXHR);
				// console.log(textStatus);
				if (jqXHR.status == 504) {
					renderWsLeftMenu();
					renderLeftMenu("teamPeek");
					const wsUrl = `${workstreamPageURL}?teamId=${teamId}&teamView`;
					triggerLeftMenu(wsUrl, false, "menu-wb-workstreams");
					$(window).scrollTop(0);
					wsSyncProgress.dialogOpen();
					setTimeout(() => {
						wsSyncProgress.dialog("close");
					}, 10000);
				}
			});
	}
	return false;
};

export const WbDateYearFormat = {
	format: "M d, yy",
	getFormateYeardDate(date, format) {
		const _format = typeof format === "undefined" ? this.format : format;
		if (date) {
			const systemOffset = moment().utcOffset() * 60 * 1000;
			return $.datepicker.formatDate(_format, new Date(date * 1000 - systemOffset));
		}
	},
	getDateFormat(date, format) {
		if (typeof date === "undefined" || date == null || date == "") {
			return "";
		}
		format = typeof format === "undefined" ? "MMM DD, YYYY" : format;
		const systemOffset = moment().utcOffset() * 60 * 1000;
		const _sDate = parseInt(date) * 1000 - systemOffset;
		return moment(_sDate).format(format);
	},
	getSystemOffset() {
		return moment().utcOffset() * 60 * 1000;
	}
};

export const getActivityStateText = function (id) {
	let _stateText = "";
	if (id == "0") {
		_stateText == "done";
	} else if (id == "1") {
		_stateText = "doing";
	} else if (id == "2") {
		_stateText = "next";
	} else if (id == "3") {
		_stateText = "redflag";
	} else if (id == "4") {
		_stateText = "pause";
	}
	return _stateText;
};

export const autoResizeTextArea = function (eleId) {
	$(eleId)
		.css({ height: "auto", "overflow-y": "hidden" })
		.css("height", $(eleId)[0].scrollHeight);
};

export const PopupInit = function (id) {
	const popupelement = id;
	if (!$(popupelement).hasClass("ui-dialog-content")) {
		$(popupelement).dialog({
			autoOpen: false,
			resizable: false,
			minHeight: 240,
			minWidth: 700,
			modal: true,
			open(event, ui) {
				$(popupelement)
					.siblings("div.ui-dialog-titlebar")
					.remove();
				$(popupelement)
					.parents("div.ui-dialog")
					.css("padding", "0");
				$(popupelement).css({ "min-height": "135px" });
				$(popupelement)
					.parent()
					.addClass("dialogbox-shadow");
				const type = $(popupelement).data("type");
				$(popupelement).dialog("option", "width", type == "ai" ? 700 : 700);
			}
		});
	}
};

export const getWsProgressColor = function (health) {
	let pColor;
	switch (health.toString()) {
		case "1" || 1 || "1":
			pColor = "#339933";
			break;
		case "2" || 2 || "2":
			pColor = "#476C89";
			break;
		case "3" || 3 || "3":
			pColor = "#db3a1b";
			break;
		default:
			pColor = "#476C89";
			break;
	}
	return pColor;
};

export const getPaceText = function (health) {
	if (health == 1) {
		return t("SLOW");
	}
	if (health == 2) {
		return t("STEADY");
	}
	return t("FAST");
};

export const getPriorityText = function (priority) {
	if (priority == 1) {
		return t("P1");
	}
	if (priority == 2) {
		return t("P2");
	}
	if (priority == 3) {
		return t("P3");
	}
	if (priority == 4) {
		return t("P4");
	}
	return t("P5");
};

export const getHealthText = function (health) {
	const healthData = [];
	if (health == 1) {
		healthData.healthName = t("GOOD");
		healthData.healthImage = "GOOD.png";
	} else if (health == 2) {
		healthData.healthName = t("OK");
		healthData.healthImage = "OK.png";
	}
	if (health == 3) {
		healthData.healthName = t("RISK");
		healthData.healthImage = "RISK.png";
	}
	return healthData;
};

/**
 * convert form searilize array to json object.
 * @param {*} formArray
 */
export const ConvertFormArrayToJson = formArray => {
	const json = {};
	jQuery.each(formArray, function () {
		json[this.name] = this.value || "";
	});
	return json;
};

function split(val) {
	return val.split(/@/);
}
function splitWithSpace(val) {
	return val.split(/ @/);
}
function extractLast(term, spaceChk = false) {
	if (spaceChk) {
		let res = term.substring(0, 1);
		if (res != "@") {
			return splitWithSpace(term).pop();
		} else if (res == "@" && term.split("@").length - 1 > 1) {
			return splitWithSpace(term.slice(1)).pop();
		} else if (res == "@" && term.split("@").length - 1 == 1) {
			return split(term).pop();
		} else {
			return splitWithSpace(term).pop();
		}
	}
	return split(term).pop();
}

const findLastOccurenceChar = val => {
	let findVal = "";
	if (val && val != null) {
		let findAt = val.lastIndexOf("@");
		let findHash = val.lastIndexOf("#");
		if (findAt !== -1 && findHash !== -1) {
			return findAt > findHash ? "@" : "#";
		} else if (findAt !== -1) {
			return "@";
		} else if (findHash !== -1) {
			return "#";
		}
	}
	return findVal;
};

export const registerQuickAddAutoComplete = (selector, tableType = "topic") => {
	const enableQuickAdd = $(selector).attr("data-enable-quickadd");
	if (enableQuickAdd != "true") {
		return;
	}
	$(selector).autocomplete({
		minLength: 1,
		source(request, response) {
			const ele = $(this).get(0).element;
			const quickAddSymbols = extractLastCharFromString(request.term);
			const findLastChar = findLastOccurenceChar(quickAddSymbols);
			let meTest = extractLastCharFromString(request.term);
			const teamId = $(ele).data("teamId");
			const tagId = $(ele).data("quickAddUserId");
			if (meTest.indexOf("@") != -1) {
				//testMe = meTest.split('@');
				let lastCharVal = meTest.lastIndexOf("@");
				meTest = meTest.substring(lastCharVal, meTest.length);
			}
			// console.log('quickAddSymbols', quickAddSymbols);
			if (!request.term.match(/#(.*)#/)) {
				$(ele).data("teamId", "");
			}
			if (quickAddSymbols.substr(0, 1) == "#" && findLastChar == "#") {
				let wsString = extractLastCharFromString(request.term);
				let lastCharVal1 = wsString.lastIndexOf("#");
				meTest = wsString.substring(lastCharVal1, wsString.length);
				$.ajax({
					url: `${wbConfig.baseUrl}/activity/quickAdd`,
					type: "GET",
					dataType: "json",
					data: { term: meTest, teamId, tagId }
				}).done(data => {
					// data  = data.data;
					const reqTerm = request.term.replace(/@/g, "");
					const re = $.ui.autocomplete.escapeRegex(
						extractLastCharFromString(reqTerm)
					);
					const matcher = new RegExp(re, "ig");
					response(
						$.map(data, (item, key) => {
							let $teamName = "";
							if (
								typeof item.teamName !== "undefined" &&
								item.teamName &&
								item.teamName != ""
							) {
								$teamName = ` - ${item.teamName}`;
							}
							const itemLabel = item.label.replace(/@/g, "");
							if (matcher.test(itemLabel)) {
								if (itemLabel.indexOf("SelfMe") > -1) {
									item.label = item.label.replace(/SelfMe/g, "");
								}
								return {
									label: item.fullName + $teamName,
									value: item.label,
									id: key,
									teamId: item.teamId,
									teamName: item.teamName,
									fullName: item.fullName
								};
							}
						})
					);
				});
			} else if (quickAddSymbols.substr(0, 1) == "@" && findLastChar == "@") {
				if (meTest.length > 3) {
					$.ajax({
						url: `${wbConfig.baseUrl}/activity/quickAdd`,
						type: "GET",
						dataType: "json",
						data: {
							limitSearch: 1,
							term: meTest,
							teamId,
							tagId
						}
					}).done(data => {
						response(
							$.map(data, (item, key) => {
								let $teamName = "";
								if (
									typeof item.teamName !== "undefined" &&
									item.teamName &&
									item.teamName != ""
								) {
									$teamName = ` - ${item.teamName}`;
								}
								const itemLabel = item.label.replace(/@/g, "");

								if (itemLabel.indexOf("SelfMe") > -1) {
									item.label = item.label.replace(/SelfMe/g, "");
								}
								return {
									label: item.fullName + $teamName,
									value: item.label,
									id: item.userId,
									teamId: item.teamId,
									teamName: item.teamName,
									fullName: item.fullName
								};
							})
						);
					});
				} else {
					response({});
				}
			} else if (
				quickAddSymbols.match(/(\!)(\d)+(\?)*/g) ||
				quickAddSymbols.substr(0, 1) == "{"
			) {
				$(ele).data("quickAddAI", true);
			}
		},
		focus(event, ui) {
			// prevent value inserted on focus
			return false;
		},
		select(event, ui) {
			setTimeout(() => {
				$(selector).trigger("click");
				WbEventHandlerMixins.placeCaretAtEnd($(selector).get(0));
			}, 10);
			// pressing enter should not trigger enter in parent elements
			event.stopImmediatePropagation();

			// let typedVal = $(this).text();
			let typedValNew = $(this).html();
			let addStrToat = [];
			if (typedValNew.indexOf("@") != -1 && ui.item.value.match(/@(.*)@/)) {
				// replace with empty text if already have owner
				if (typedValNew.match(/@(.*)@/)) {
					let findLastIndexOfOwner = typedValNew.lastIndexOf("@");
					if (findLastIndexOfOwner !== -1) {
						let firstHalfChar = typedValNew.substring(0, findLastIndexOfOwner);
						let lastHalfChar = typedValNew.substring(
							findLastIndexOfOwner,
							typedValNew.length
						);
						if (firstHalfChar.length) {
							firstHalfChar = firstHalfChar.replace(/@(.*)@/, "");
						}
						typedValNew = firstHalfChar + lastHalfChar;
					}
				}
				let addStrToat1 = typedValNew.split("@");
				if (addStrToat1[0].indexOf("@") === -1) {
					addStrToat.push(addStrToat1[0]);
				}
				addStrToat.push(`@${addStrToat1[1]}@`);
				// let res = typedValNew.substring(0, 1);
				// if (res != '@') {
				// 	addStrToat = splitWithSpace(typedValNew);
				// 	addStrToat[1] = `@${addStrToat[1]}@`;
				// 	//console.log(addStrToat,"1");
				// } else if ((res == '@') && (typedValNew.split('@').length - 1) > 1) {
				// 	addStrToat = splitWithSpace(typedValNew);
				// 	addStrToat[0] = `@${addStrToat[0]}@`;
				// 	//console.log(addStrToat,"2");
				// } else if ((res == '@') && (typedValNew.split('@').length - 1) == 1) {
				// 	addStrToat = split(typedValNew);
				// 	addStrToat[1] = `@${addStrToat[1]}@`;
				// 	//console.log(addStrToat,"3");
				// } else {
				// 	addStrToat = splitWithSpace(typedValNew);
				// 	addStrToat[0] = `@${addStrToat[0]}@`;
				// 	//console.log(addStrToat,"4");
				// }
				//console.log(addStrToat,"addStrToat");
			}
			if (typedValNew.indexOf("#") != -1 && ui.item.value.match(/#(.*)#/)) {
				// replace with empty text if already have workstream
				if (typedValNew.match(/#(.*)#/)) {
					let findLastIndexOfOwner = typedValNew.lastIndexOf("#");
					if (findLastIndexOfOwner !== -1) {
						let firstHalfChar = typedValNew.substring(0, findLastIndexOfOwner);
						let lastHalfChar = typedValNew.substring(
							findLastIndexOfOwner,
							typedValNew.length
						);
						if (firstHalfChar.length) {
							firstHalfChar = firstHalfChar.replace(/#(.*)#/, "");
						}
						typedValNew = firstHalfChar + lastHalfChar;
					}
				}
				let addStrToat1 = typedValNew.split("#");
				if (addStrToat1[0].indexOf("#") === -1) {
					addStrToat.push(addStrToat1[0]);
				}
				addStrToat.push(`#${addStrToat1[1]}#`);
			}
			// console.log('addStrToat', addStrToat);
			// var terms = splitSpaceChars(typedVal);
			// remove the current input
			// terms.pop();
			if (addStrToat.length > 0) {
				addStrToat.pop();
			}
			// add the selected item
			const varTitle = $("<div />")
				.html(ui.item.value)
				.text();
			// // terms.push(varTitle);
			// if (addStrToat == '') {
			// 	addStrToat = [];
			// }
			addStrToat.push(varTitle);
			// add placeholder to get the comma-and-space at the end
			// terms.push("");
			addStrToat.push("");
			$(this).html(addStrToat.join(" ").trim());
			if (ui.item.value.substr(0, 1) == "#") {
				$(this).data("teamId", ui.item.teamId);
				$(this).data("quickAddTagId", ui.item.id);
				$(this).data("quickAddAI", true);
			}
			if (ui.item.value.substr(0, 1) == "@") {
				$(this).data("quickAddUserId", ui.item.id);
				$(this).data("quickAddAI", true);
			}
			return false;
		},
		open(event, ui) {
			const posVal = getCaretPosition($(selector));
			const typedVal = $(this).text();
			$(this)
				.data("ui-autocomplete")
				.menu.element.addClass("agenda-autosearch meeting-agenda-autosearch");
			if (
				extractLastCharFromString(typedVal).substr(0, 1) == "#" ||
				extractLastCharFromString(typedVal).substr(0, 1) == "@"
			) {
				const resultsList = $("ul.ui-autocomplete > li.ui-menu-item > a");
				const srchTerm = $.trim(
					extractLastCharFromString(typedVal).substring(1)
				)
					.split(/\s+/)
					.join("|");

				// --- Loop through the results list and highlight the terms.
				resultsList.each(function () {
					const jThis = $(this);
					const regX = new RegExp(`(${srchTerm})`, "gi");
					const teamname = $(this)
						.find(".teamClass")
						.text();
					$(this)
						.find(".teamClass")
						.remove();
					let oldTxt = jThis.text();
					oldTxt = $("<div />")
						.html(oldTxt)
						.text();
					jThis.html(
						`${oldTxt.replace(
							regX,
							'<span class="srchHilite">$1</span>'
						)} <span style="font-style:italic;font-size:12px;color: #999999;">${teamname}</span>`
					);
				});
				if (extractLastCharFromString(typedVal).substr(0, 1) == "#") {
					var s =
						'<li class="ui-menu-item-header" role="presentation" ><a style="background-color: #FFFFFF !important;color:#999999 !important;"><div class="cb-column">Suggested Workstreams</div></a></li>';
					$("ul.ui-autocomplete[style*='block']").prepend(s);
				}
				if (extractLastCharFromString(typedVal).substr(0, 1) == "@") {
					var s =
						'<li class="ui-menu-item-header" role="presentation" ><a style="background-color: #FFFFFF !important;color:#999999 !important;"><div class="cb-column">Suggested Assignees</div></a></li>';
					$("ul.ui-autocomplete[style*='block']").prepend(s);
				}
			}
			if (
				$(".meeting-agenda-autosearch.ui-autocomplete.ui-widget-content").find(
					"li"
				).length
			) {
				$(
					".meeting-agenda-autosearch.ui-autocomplete.ui-widget-content"
				).addClass("meet-autosearch-border");
			}
		},
		create(event, ui) {
			const ele = $(this).get(0).element;
			const eleId = $(ele).attr("id");
			$(this).data("ui-autocomplete")._renderItem = function (ul, item) {
				return $("<li>")
					.addClass("ui-menu-item-header")
					.attr("role", "presentation")
					.append(
						`<a>${item.fullName}<span class="teamClass" >${item.teamName}</span></a>`
					)
					.appendTo(ul);
			};
		}
	});
};

const getCaretPosition = editableDiv => {
	let caretPos = 0;
	let sel;
	let range;
	if (window.getSelection) {
		sel = window.getSelection();
		if (sel.rangeCount) {
			range = sel.getRangeAt(0);
			if (range.commonAncestorContainer.parentNode == editableDiv) {
				caretPos = range.endOffset;
			}
		}
	} else if (document.selection && document.selection.createRange) {
		range = document.selection.createRange();
		if (range.parentElement() == editableDiv) {
			const tempEl = document.createElement("span");
			editableDiv.insertBefore(tempEl, editableDiv.firstChild);
			const tempRange = range.duplicate();
			tempRange.moveToElementText(tempEl);
			tempRange.setEndPoint("EndToEnd", range);
			caretPos = tempRange.text.length;
		}
	}
	return caretPos;
};

const splitSpaceChars = val => val.split(/ \s*/);
const extractLastCharFromString = term => splitSpaceChars(term).pop();

export const quickAddEventHandler = obj => {
  const fieldData = $(obj).serialize();
  if (obj.nodeName && obj.nodeName != "DIV") {
    $(obj).attr("disabled", "disabled");
  }
	const valid = true;
	const quickAddText = $.trim($(obj).text());
	const workstremFind = quickAddText.match(/\#+/g);
	if (workstremFind) {
		const workstremLen = workstremFind.length;
		if (workstremLen == 1) {
			alert(
				"Workstreams need to have a '#' before and after the workstream name to be recognized, like this: #Workstream Name#"
			);
      if (obj.nodeName && obj.nodeName != "DIV") {
        $(obj).removeAttr("disabled", "disabled");
      }
			return false;
		}
		if (workstremLen > 2) {
			alert("Workstream specified more than one time.");
      if (obj.nodeName && obj.nodeName != "DIV") {
        $(obj).removeAttr("disabled", "disabled");
      }
			return false;
		}
	}
	const assigneeFind = quickAddText.match(/\@+/g);
	if (assigneeFind) {
		const assigneeLen = assigneeFind.length;
		if (assigneeLen == 1) {
			alert(
				"Assignee names need to have an '@' symbol before and after the name, like this: @John@"
			);
      if (obj.nodeName && obj.nodeName != "DIV") {
        $(obj).removeAttr("disabled", "disabled");
      }
			return false;
		}
		if (assigneeLen > 2) {
			alert("Assignee specified more than one time.");
      if (obj.nodeName && obj.nodeName != "DIV") {
        $(obj).removeAttr("disabled", "disabled");
      }
			return false;
		}
	}

	const dueDateFind = quickAddText.match(/(\!)(\d)+(\?)*/g);
	if (dueDateFind) {
		const dueDateLen = dueDateFind.length;
		if (dueDateLen > 1) {
			alert("Due Date specified more than one time.");
      if (nodeName != "DIV") {
        $(obj).removeAttr("disabled", "disabled");
      }
			return false;
		}
	}
	return true;
};

export const DeleteBoardAlertBox = function (id) {
	$(id).dialog({
		autoOpen: false,
		resizable: false,
		minHeight: 240,
		width: 365,
		modal: true,
		open(event, ui) {
			$(id)
				.siblings("div.ui-dialog-titlebar")
				.remove();
			$(id)
				.parents("div.ui-dialog")
				.css("padding", "0");
			$(id).css({ "min-height": "135px" });
			$(id)
				.parent()
				.addClass("dialogbox-shadow");
		}
	});
};

export const displayTimeAsHrsMins = (time = "") => {
	let disp = "";
	let hours = 0;
	let mins = 0;
	if (time) {
		if (time >= 3600) {
			hours = Math.floor(time / 3600);
			mins = time - hours * 3600;
			mins = mins >= 60 ? Math.ceil(mins / 60) : 0;
			if (hours) {
				disp = `${hours}h`;
			}
			if (mins) {
				disp = `${disp} ${mins}m`;
			}
		} else {
			mins = Math.ceil(time / 60);
			if (mins) {
				disp = `${disp} ${mins}m`;
			}
		}
	}
	return disp;
};

export const escapeRegExp = (str) => {
	return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

export const searchMatchedTextValue = (str, matchStr) => {
	if (str) {
		matchStr = matchStr.replace(new RegExp("\\\\", "g"), "\\\\");
		const regExp = new RegExp(escapeRegExp(matchStr), "i");
		return new String(str).match(regExp) !== null;
	}
	return false;
};

export const replaceUScoreWithSpace = function (str) {
	if (str && str.length > 0) {
		return str.replace(/ /g, "_");
	}
};

export const getTopMenuKey = function (object) {
	let key = "";
	switch (object) {
		case TopMenuConst.OBJECT_TYPE_ACTIVITY:
		case TopMenuConst.OBJECT_TYPE_ACTIVITY_MYWORK:
		case TopMenuConst.RECENT_TYPE_ACTIVITY:
			key = "mywork";
			break;
		case TopMenuConst.OBJECT_TYPE_BOARD:
		case TopMenuConst.RECENT_TYPE_BOARD:
		case TopMenuConst.OBJECT_TYPE_WS:
		case TopMenuConst.RECENT_TYPE_WS:
			key = "board";
			break;
		case TopMenuConst.OBJECT_TYPE_GOAL:
		case TopMenuConst.RECENT_TYPE_GOAL:
		case TopMenuConst.OBJECT_TYPE_TEAM_GOAL:
		case TopMenuConst.OBJECT_TYPE_USER_GOAL:
		case TopMenuConst.OBJECT_TYPE_MY_OBJECTIVE:
		case TopMenuConst.OBJECT_TYPE_PERSONKR:
			key = "objectives";
			break;
		case TopMenuConst.OBJECT_TYPE_MEETING:
		case TopMenuConst.RECENT_TYPE_MEETING:
			key = "meetings";
			break;
		case TopMenuConst.OBJECT_TYPE_TEAM:
		case TopMenuConst.RECENT_TYPE_TEAM:
			key = "teams";
			break;
		case TopMenuConst.OBJECT_TYPE_RBR:
		case TopMenuConst.RECENT_TYPE_RBR:
			key = "rbr";
			break;
		default:
			key = object;
			break;
	}
	return key;
};

export const getLeftMenuKey = function (object) {
	let key = "";
	switch (object) {
		case TopMenuConst.OBJECT_TYPE_ACTIVITY:
		case TopMenuConst.RECENT_TYPE_ACTIVITY:
			key = "mywork";
			break;
		case TopMenuConst.OBJECT_TYPE_BOARD:
		case TopMenuConst.RECENT_TYPE_BOARD:
		case TopMenuConst.OBJECT_TYPE_WS:
		case TopMenuConst.RECENT_TYPE_WS:
			key = "board";
			break;
		case TopMenuConst.OBJECT_TYPE_GOAL:
		case TopMenuConst.RECENT_TYPE_GOAL:
		case TopMenuConst.OBJECT_TYPE_TEAM_GOAL:
		case TopMenuConst.OBJECT_TYPE_USER_GOAL:
		case TopMenuConst.OBJECT_TYPE_MY_OBJECTIVE:
		case TopMenuConst.OBJECT_TYPE_PERSONKR:
			key = "goal";
			break;
		case TopMenuConst.OBJECT_TYPE_MEETING:
		case TopMenuConst.RECENT_TYPE_MEETING:
			key = "meeting";
			break;
		case TopMenuConst.OBJECT_TYPE_TEAM:
		case TopMenuConst.RECENT_TYPE_TEAM:
			key = "team";
			break;
		case TopMenuConst.OBJECT_TYPE_RBR:
		case TopMenuConst.RECENT_TYPE_RBR:
			key = "rbr";
			break;
		default:
			key = object;
			break;
	}
	return key;
};

export const RemoveDuplicateItemsInLeftMenu = (arr, objKey) => {
	if (typeof objKey !== "undefined" && objKey != null) {
		arr = Object.values(
			arr.reduce(
				(r, e) =>
					(r[objKey === "board" ? `${e.obj_type}_${e.obj_id}` : e.obj_id] = e),
				r,
				{}
			)
		);
	}
	return arr;
};

/**
 * Matches {@link getZendeskWidgetZindex} fallback in wb/js/workboard.js when the launcher iframe has no z-index.
 */
const ZENDESK_STACK_FALLBACK_Z_INDEX = 999999;

/**
 * Z-index for KR weight dialog: one above the Zendesk stacking base so {@link reactLoader} (base + 2) still covers it.
 *
 * @returns {number}
 */
export function getKrWeightModalZIndex() {
	if (typeof getZendeskWidgetZindex !== 'function') {
		return ZENDESK_STACK_FALLBACK_Z_INDEX + 1;
	}
	const raw = getZendeskWidgetZindex();
	const base =
		typeof raw === 'number' && Number.isFinite(raw)
			? raw
			: ZENDESK_STACK_FALLBACK_Z_INDEX;
	return base + 1;
}

export const reactLoader = (visibleOverlay = true) => {
	if ($("#ajaxloaderR").length) {
		$("#ajaxloaderR").remove();
	}
	const div =
		'<div id="ajaxloaderR" class="spinner"><div class="spinner-container container1"><div class="circle1"></div><div class="circle2"></div><div class="circle3"></div><div class="circle4"></div></div><div class="spinner-container container2"><div class="circle1"></div><div class="circle2"></div><div class="circle3"></div><div class="circle4"></div></div><div class="spinner-container container3"><div class="circle1"></div><div class="circle2"></div><div class="circle3"></div><div class="circle4"></div></div></div></div>';
	$(document.fullscreenElement || "body").append("<div id='overlay'></div>");
	$(div).prependTo($("#overlay"));
	const zIndex = getZendeskWidgetZindex();
	$("#overlay").css({
		height: "100%",
		position: "fixed",
		top: 0,
		left: 0,
		"background-color": visibleOverlay ? "rgba(0, 0, 0, 0.1)" : "",
		width: "100%",
		"z-index": zIndex + 2,
		display: "block"
	});
	$("#ajaxloaderR")
		.css({
			position: "fixed",
			top: "45%",
			left: "48%",
			"z-index": zIndex + 3
		})
		.show();
};

export const removeReactLoader = () => {
	if ($("#ajaxloaderR").length) {
		$("#ajaxloaderR").remove();
	}
	if ($("#ajaxloader").length) {
		$("#ajaxloader").remove();
	}
	if ($("#overlay").length) {
		$("#overlay").remove();
	}
};

export const buildFormData = (formData, data, parentKey) => {
	if (
		data &&
		typeof data === "object" &&
		!(data instanceof Date) &&
		!(data instanceof File)
	) {
		Object.keys(data).forEach(key => {
			buildFormData(
				formData,
				data[key],
				parentKey ? `${parentKey}[${key}]` : key
			);
		});
	} else {
		const value = data == null ? "" : data;

		formData.append(parentKey, value);
	}
};

export const jsonToFormData = data => {
	const formData = new FormData();
	buildFormData(formData, data);
	return formData;
};

export const wbDebounce = (func, wait) => {
	let timeout = null;
	return function () {
		const context = this;
		const args = arguments;
		clearTimeout(timeout);
		timeout = setInterval(() => func.apply(context, args), wait);
	};
};

export const createOkrPeriodName = (
	quarter,
	year,
	okrPeriodType = 1
) => {
	// Handle FY period type (okrPeriodType == 2)
	if (okrPeriodType == 2) {
		const lastTwoDigit = `${year}`.substring(2);
		return `FY${lastTwoDigit}`.trim();
	}
	
	// Check if quarter is already a formatted trimester (T1, T2, T3) or half-year (H1, H2)
	// or if it contains the full period name like "T1 2026"
	const quarterStr = String(quarter || '').trim();
	if (quarterStr && (quarterStr.startsWith('T') || quarterStr.startsWith('H'))) {
		// If it's already a full period name like "T1 2026", return it as is
		if (quarterStr.includes(' ')) {
			return quarterStr;
		}
		// Otherwise format it as "T1 2026" or "H1 2026"
		return `${quarterStr} ${year}`.trim();
	}
	
	// Regular quarter format: "Q1 FY26"
	const lastTwoDigit = `${year}`.substring(2);
	return `${quarter} FY${lastTwoDigit}`.trim();
}

export const getQuarterStartYear = (goalStart, goalEnd, orgPeriod = undefined) => {
	var quarterStartYear = goalStart.substr(-4);
	if(orgPeriod){
		//orgPeriod = orgPeriod.filterOption ? orgPeriod.filterOption : orgPeriod;
		var result = Object.keys(orgPeriod).map((key) => orgPeriod[key]);
		const fiscalYearPeriods = result.filter((p) => (p._isFullYear == true));
		const fpLen = fiscalYearPeriods.length;
		var hasYearOffset = result.filter((p) => (p.yearOffset == 1));

		if(fpLen && hasYearOffset.length){
			for(let fp = 0; fp < fpLen; fp++){
				let fiscalPeriod = fiscalYearPeriods[fp];
				let fiscalPeriodStart = fiscalPeriod['start'];
				let fiscalPeriodEnd = fiscalPeriod['end'];
				let goalStartYear = goalStart.substr(-4);
				let goalEndYear = goalEnd.substr(-4);
				let yearDiff = parseFloat(goalEndYear) - parseFloat(goalStartYear);
				if(fiscalPeriodStart == goalStart && fiscalPeriodEnd == goalEnd){
					quarterStartYear++;
					break;
				}else if((fiscalPeriodStart.substr(0,5) == goalStart.substr(0,5)) && (fiscalPeriodEnd.substr(0,5) == goalEnd.substr(0,5)) && (yearDiff == 0 || yearDiff ==1)){
					quarterStartYear++;
					break;
				}
			}
		}
	}
	return quarterStartYear;
}

const createQuarterEndDate = (orgReportingPeriods, startDate, isOrgPeriodMatch) => {
	if (isOrgPeriodMatch && Array.isArray(orgReportingPeriods) && orgReportingPeriods.length) {
		let year = moment(startDate).format('YYYY');
		const findQuarter = orgReportingPeriods.filter(
			o => moment(startDate).isSame(o.start + '/' + year)
		)
		if (findQuarter && findQuarter.length) {
			let endD = moment(findQuarter[0]['end'] + '/' + year)
			if (!moment(endD).isAfter(startDate)) {
				year = parseInt(year) + 1;
				endD = moment(findQuarter[0]['end'] + '/' + year)
			}
			return endD.format('MMM DD, YYYY');
		}
	}
	return moment(startDate)
		.add(3, 'M').subtract(1, "days")
		.format("MMM DD, YYYY");
}

export const createQuarterIntervals = (
	type = "month",
	start_date = undefined,
	target_date = undefined,
	quarter_start_date = undefined,
	nestedFlow = false,
	orgPeriod = undefined,
	orgReportingPeriods = undefined
) => {
  let dateSegments = [];
	let quarterMap = {
		0: "Q1",
		1: "Q2",
		2: "Q3",
		3: "Q4",
		"-0": "Q1",
		"-1": "Q4",
		"-2": "Q3",
		"-3": "Q2"
	};
	let weekIndex = 1;
	const endDate = moment(target_date).format("MMM DD, YYYY");
	let startDate = moment(start_date);
	// moment(endDate,"MMM DD, YYYY").year()
	// let year = isFiscal ? isFiscal : moment(startDate,"MMM DD, YYYY").year();
	// 16420. When fiscal year is custom get Q4 end_date
	let year = moment(endDate,"MMM DD, YYYY").year();
	let mYear= getQuarterStartYear(moment(start_date).format('MM/DD/YYYY'), moment(target_date).format('MM/DD/YYYY'), orgPeriod); //year;
	let quarterStart = !!nestedFlow ?  start_date : moment.unix(quarter_start_date).format("MMM DD, YYYY");
	let i=0;
	let isOrgPeriodMatch = false;
	if (Array.isArray(orgReportingPeriods) && orgReportingPeriods.length) {
		const startYear = moment(startDate).format('YYYY');
		isOrgPeriodMatch = moment(startDate).isSame(orgReportingPeriods[0].start + '/' + startYear)
	}
	while (moment(startDate).isBefore(moment(endDate))) {
		let obj = {};
		let newEndDate;
		if(!!nestedFlow) {
			if(type == "month") {
				newEndDate = moment(startDate)
				.add(1, 'M').subtract(1, "days")
				.format("MMM DD, YYYY");
			} else if (type == "week"){
				newEndDate = moment(startDate)
				.add(6, 'days')
				.format("MMM DD, YYYY");
			} else {
				newEndDate = createQuarterEndDate(orgReportingPeriods, startDate, isOrgPeriodMatch);
			}
		} else {
			if(type === 'week'){
				newEndDate = moment(startDate)
				.add(6, 'days')
				.format("MMM DD, YYYY");
			}else if(type === 'quarter'){
				newEndDate = moment(startDate)
				.add(3, 'M').subtract(1, "days")
				.format("MMM DD, YYYY");
			}else {
				newEndDate = moment(startDate)
				.endOf(type)
				.format("MMM DD, YYYY");
			}
		}
		if (moment(newEndDate).isAfter(endDate)) {
			obj["endDate"] = endDate;
		} else {
			obj["endDate"] = newEndDate;
		}
		obj["startDate"] = moment(startDate).format("MMM DD, YYYY");
		if (type === "quarter") {
			let monthDiff = parseInt(
				moment(startDate)
					.add(1, "days")
					.diff(moment(quarterStart).add(1, "days"), "months", true)
			);
			const quarterEndYear = moment(obj["startDate"],"MMM DD, YYYY").year();
			if (quarterEndYear <= year && i > 3 && (i % 4) == 0) {
				mYear++;
			}
			let checkQuarter = 0;
			if (monthDiff % 3 == 0) {
				// if month different is more than 12 months then divided by 12
				if (monthDiff >= 12 || -12 >= monthDiff) {
					monthDiff = monthDiff % 12;
				}
				checkQuarter = Math.round(monthDiff / 3);
			} else {
				checkQuarter = Math.ceil((monthDiff / 3) % 3);
			}
			obj["intervalName"] = quarterMap[checkQuarter];
			obj["quarterName"] = createOkrPeriodName(quarterMap[checkQuarter], mYear);
			obj["year"] = mYear;
		} else if (type === "week"){
			obj["intervalName"] = `Week ${weekIndex}`;
			obj["quarterName"] = '';
			obj["year"] = year;
			weekIndex++;
		} else {
			obj["intervalName"] = moment(startDate).format("MMMM");
			let monthDiff = parseInt(
				moment(startDate)
					.add(1, "days")
					.diff(moment(quarterStart).add(1, "days"), "months", true)
			);
			const quarterEndYear = moment(obj["startDate"],"MMM DD, YYYY").year();
				if (quarterEndYear <= year && i > 3 && (i % 4) == 0) {
					mYear++;
				}
			let endYear = mYear;
			if (monthDiff % 3 == 0) {
				// if month different is more than 12 months then divided by 12
				if (monthDiff >= 12 || -12 >= monthDiff) {
					monthDiff = monthDiff % 12;
				}
				let checkQuarter = Math.round(monthDiff / 3);
				obj["quarterName"] = createOkrPeriodName(quarterMap[checkQuarter], endYear);
				obj["year"] = endYear;
			}
		}
		startDate = moment(newEndDate).add(1, "days");
		dateSegments.push(obj);
		i++;
	}
	return dateSegments;
};

export const getGoalsCount = (teams, type) => {
	let goalCount = 0;
	if (typeof teams !== 'undefined' && teams.length > 0) {
		if (type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_OKR) {
			teams.map(items => {
				if (typeof items.teams !== 'undefined' && items.teams.length > 0) {
					items.teams.map(item => {
						if (item.goals !== 'undefined' && items.teams.length > 0) {
							let count = item.goals.length > 0 ? item.goals.length : 0;
							goalCount += parseInt(count);
						}
					})
				}
			})
		} else if (type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR || type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH || type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE) {
			teams.map(items => {
				if (typeof items.teams !== 'undefined' && items.teams.length > 0) {
					items.teams.map(item => {
						if (item.metrics !== 'undefined' && item.metrics.length > 0) {
							let count = item.metrics.length > 0 ? item.metrics.length : 0;
							goalCount += parseInt(count);
							return goalCount;
						}
					})
				}
			})
		} else {
			teams.map(item => {
				let count = item.goals.length > 0 ? item.goals.length : 0;
				goalCount += parseInt(count)
			})
		}
	}
	return goalCount;

}

export const wbStripHtmlEvents = function (strText) {
	let _stateText = '';
	if (strText.indexOf("onmouseenter=") !== -1 ) {
		_stateText = strText.replace("onmouseenter=", " ");
	}
	if (strText.indexOf("onload=") !== -1 ) {
		_stateText = strText.replace("onload=", " ");
	}
	if (strText.indexOf("onClick=") !== -1 ) {
		_stateText = strText.replace("onClick=", "");
	}
	if (strText.indexOf("onKeypress=") !== -1 ) {
		_stateText = strText.replace("onKeypress=", " ");
	}
	if (strText.indexOf("onkeydown=") !== -1 ) {
		_stateText = strText.replace("onkeydown=", " ");
	}
	if (strText.indexOf("onkeyup=") !== -1 ) {
		_stateText = strText.replace("onkeyup=", " ");
	}
	if (strText.indexOf("ondblclick=") !== -1 ) {
		_stateText = strText.replace("ondblclick=", " ");
	}
	if (strText.indexOf("onmouseleave=") !== -1 ) {
		_stateText = strText.replace("onmouseleave=", " ");
	}
	if (strText.indexOf("onfocus=") !== -1 ) {
		_stateText = strText.replace("onfocus=", " ");
	}
	if (strText.indexOf("onblur=") !== -1 ) {
		_stateText = strText.replace("onblur=", " ");
	}
	if (strText.indexOf("onunload=") !== -1 ) {
		_stateText = strText.replace("onunload=", " ");
	}
	if (strText.indexOf("onscroll=") !== -1 ) {
		_stateText = strText.replace("onscroll=", " ");
	}
	if (strText.indexOf("alert(") !== -1 ) {
		_stateText = strText.replace("alert(", " ");
	}else{
		_stateText = strText;
	}
	return _stateText;
};


/**
 * html html entities
 * use Reactjs dangerouslySetInnerHTML
 */
export const htmlEntities = function (str) {
	return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
};

/**
 * remove the emoji from content
 * @param {*} text
 */
export const removeEmojiContent = (text) => {
	return text.replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g, '');
}

/*
get the AI priority Icon based on priority value
*/
export const getPriorityId = (
	priority
) => {
	if (priority == 1) {
		return "priority_highest";
	} else if (priority == 2) {
		return "priority_high";
	}
	return ''
}

/*
get the AI State Icon based on State value
*/
export const getStateId = (
	state
) => {
	if (state == "0") {
		return "green_state";
	} else if (state == "1") {
		return "doing_state";
	} else if (state == "2") {
		return "next_state";
	} else if (state == "4") {
		return "pause_state";
	}
	return ''
}
/*
get the AI Rag Icon based on Rag value
*/
export const getRagId = (
	rag
) => {

	if (rag == "0") {
		return "green";
	} else if (rag == "1") {
		return "amber";
	} else if (rag == "2") {
		return "red";
	}
	return ''
}

export const validateImageFileExtension = fileName => {
	let isValid = true;
	const allowedExtensions =  /(\.jpg|\.jpeg|\.png|\.gif)$/i;
	//validation for image file
	if (!allowedExtensions.exec(fileName)) {
		isValid = false;
		toastr['error']('Invalid file type.');
	}
	return isValid;
}

export const getUserId = data => {
	if(data.includes('data-userid=')){
		return data.split('data-userid="')[1].split('"')[0];
	}
	return;
}
export const getWsTagId = data =>{
	if(data.includes('data-quickaddtagid=')){
		return data.split('data-quickaddtagid="')[1].split('"')[0];
	}
	return ;
}

/**
 * Adds a slash to the end of a url if it doesn't currently exist
 * @param url
 * @return string
 */
export const appendSlashToUrl = (url = "") => {
	if (url && !url.endsWith("/")) {
		return url + "/";
	} else {
		return url;
	}
}


/**
 * returns offset object of the element. jQuery Alternative of .offset()
 * @param element
 * @return object
 */
export const getOffset = (element) => {
	if (!element || !element.getClientRects().length){
		return { top: 0, left: 0 };
	}

	let rect = element.getBoundingClientRect();
	let win = element.ownerDocument.defaultView;
	return ({
		top: rect.top + win.pageYOffset,
		left: rect.left + win.pageXOffset
	});
}

export const openActionItemPopUp = (
	subaiId,
	items,
	popupelement,
	closePopup,
	tagId,
	parent,
	elementId,
	focusLock = false,
) => {

	function subAIClosePopup() {
		if (document.getElementById("rbr-add-popup-wrapper")) {
			ReactDOM.unmountComponentAtNode(
				document.getElementById("rbr-add-popup-wrapper")
			);
		}
		if($('.ai-full-view').css('display') != 'none') {
			$('.ai-full-view').attr('tabindex', '-1');
		}
		closePopup();
	}

	function addSubAiItem(params, e) {
		const _this = this;
		const evt = $(e.target);
		const type = "ai";
		const filteredItems = params.items;
		$(".wbmodalmodalClass .errormsg").hide();
		if (filteredItems.length == 0) {
			$(".wbmodalmodalClass .errormsg")
				.show()
				.html("Please select parent issue.");
			return;
		}

		// do action here.
		if (type == "ai") {
			const params = { actId: subaiId, parentId: filteredItems[0] };
			showLoaderWidget($("#content"));
			$.post(`${wbConfig.baseUrl}/activity/UpdateParentId`, params, resp => {
				if (document.getElementById("rbr-add-popup-wrapper")) {
					ReactDOM.unmountComponentAtNode(
						document.getElementById("rbr-add-popup-wrapper")
					);
				}
				subAIClosePopup();
				removeLoader();
				if ($(evt).closest(".aiDetailsActionMenuWrap").length > 0) {
					const urlVal = `${wbConfig.baseUrl}/activity/aI?id=${_this.props.actId}`;
					$("#ai-details-close").trigger("click");
					openFullPopUp(aiFullViewPopUp, urlVal, evt);
				} else {
					return backendLoadAfterSave(subaiId, false);
				}
			});
		}
	}

	const actionLabel = getAiTypeActionLabel().toLowerCase();

	ReactDOM.render(
		<AddITemModal
			id="ai"
			name={t('Choose the {{actionLabel}} to add the subtask to', { actionLabel })}
			placeholder={t('Search for an {{actionLabel}} by name or owner', { actionLabel })}
			items={items}
			closePopup={subAIClosePopup}
			addItem={addSubAiItem}
			actId={subaiId}
			tagId={tagId}
			parent={parent}
			forSubAI={true}
			focusLock={focusLock}
		/>,
		document.getElementById(elementId)
	);
	if($('.ai-full-view').css('display') != 'none') {
		$('.ai-full-view').attr('tabindex', '');
	}
	// $(popupelement).dialog("open");
} ;

window.openActionItemPopUp = openActionItemPopUp;

/**
 * function checks if file upload should be allowed
 *
 * @param component (ie meetings)
 * @param mimetype (ie application/javascript)
 * @return boolean
 *  false if mimetype is in a relevant disallowList
 *  true otherwise
 *
 *  TODO implement allow lists for components carefully so as not to impact
 *  user experience
 */
export const allowFileUpload = (component, extension) => {

  // disallow any upload where extension is unknown
  if (!extension) {
    return false;
  }

  let ext = extension.toLowerCase();

  // future use {'meetings': [], ... }
  let allowedExtensions = {};

  let disallowedExtensions = {
    'all': ['73k', '89k', 'a6p', 'ac', 'acc', 'acr', 'action', 'actm', 'ahk', 'air', 'apk', 'app',
            'apscript', 'as', 'asb', 'awk', 'azw2', 'bat', 'beam', 'bin', 'btm', 'cel', 'celx', 'chm',
            'cmd', 'cof', 'com', 'command', 'cpl', 'crt', 'csh', 'csv', 'dek', 'dld', 'dmc', 'docm',
            'dotm', 'dxl', 'ear', 'ebm', 'ebs', 'ebs2', 'ecf', 'eham', 'eicar', 'elf', 'es', 'ex4',
            'exe', 'exopc', 'ezs', 'fas', 'fky', 'fpi', 'frs', 'fxp', 'gadget', 'gs', 'ham', 'hms',
            'hpf', 'hta', 'iim', 'ins', 'inx', 'ipa', 'ipf', 'isp', 'isu', 'jar', 'job', 'js', 'jse',
            'jsx', 'kix', 'ksh', 'lnk', 'lo', 'ls', 'mam', 'mcr', 'mel', 'mpx', 'mrc', 'ms', 'msc',
            'msi', 'msp', 'mst', 'mxe', 'nexe', 'obs', 'ore', 'osx', 'otm', 'out', 'oxe', 'paf', 'pex',
            'php', 'pif', 'plx', 'potm', 'ppam', 'ppsm', 'pptm', 'prc', 'prg', 'ps1', 'pvd', 'pwc',
            'pyc', 'pyo', 'qpx', 'rbx', 'reg', 'rgs', 'rox', 'rpj', 'run', 's2a', 'sbs', 'sca', 'scar',
            'scb', 'scr', 'script', 'sct', 'shb', 'shs', 'smm', 'spr', 'tcp', 'thm', 'tlb', 'tms',
            'u3p', 'udf', 'upx', 'url', 'vb', 'vbe', 'vbs', 'vbscript', 'vlx', 'vpm', 'wcm', 'widget',
            'wiz', 'workflow', 'wpk', 'wpm', 'ws', 'wsf', 'wsh', 'xap', 'xbap', 'xlam', 'xlm', 'xlsm',
            'xltm', 'xqt', 'xys', 'zl9'],
    'meetings': [ ],
  };

	// TODO: If extensions are added to component besides 'all', add unit tests
	// to cover that case

  // if component has an allow list, and this extensions is NOT in that allow
  // list, return false
  if ( allowedExtensions.hasOwnProperty(component) &&
       !JSON.parse(allowedExtensions)[component].includes(ext) ) {
    return false;
  }

  // if disallowed by 'all' or
  //    disallowed by component
  // return false
  if ( disallowedExtensions['all'].includes(ext) ||
       disallowedExtensions[component].includes(ext)) {
    return false;
  }

  // if we're here, nothing is stopping this mimetype
  return true;

};

/**
 * construct nested krs payload
 * @param {*} props
 * @returns
 */
export const constructNestedKRPayload = (props) => {
	const { isChildKr, addOkrData = {}, nested_krs = [] } = props;
	const nestedKRParams = {};
	if( !isChildKr && typeof addOkrData.display_nested_kr !== 'undefined'
		&& addOkrData.display_nested_kr
		&& Array.isArray(nested_krs)
		&& nested_krs.length > 0
	){
        for(let i = 0; i < nested_krs.length; i++) {
            let obj = {};
            const { duration, ...kr } = nested_krs[i];
            Object.keys(kr).forEach((key) => {
              if(key == "metricMetric" || key == "metricGoal" || key == "metricMirror" || key == "selectedDs"){
                // don't pass this to backend as it was used for metadata of rollUp & mirror
              }else if(key == "metricWs"){ // for Workstream
                let dependentWsSel = kr[key];
                let dependentWs = [];
                if (Object.keys(dependentWsSel).length > 0) {
                  dependentWsSel.map(item => {
                    if (item.ws) {
                      item.ws.map(item1 => {
                        dependentWs.push(item1.id);
                      });
                    }
                  });
                }
                obj[`${key}`] = dependentWs;
              } else if(key == "metricSurvey"){ //for GroupSurvey Kr
                obj[`${key}`] = kr[key] && kr[key].length > 0 ? kr[key].map(m => m.user_id) : []
              } else if(key == "permission_teams" || key == "permission_biz"){ //for GroupSurvey Kr
                obj[`${key}`] = (kr[key] && kr[key].length > 0)
                   ? kr[key].map(m => typeof m.id !== 'undefined' ? m.id : m) : []
              } else if(key == "coOwners") {
                if (Array.isArray(kr[key])) {
                  // on editing, this is more like an user object (id, name, ...)
                  if (kr[key].length > 0) {
                    obj[`${key}`] = kr[key].map(m => m.id).join(',');
                  } else {
                    obj[`${key}`] = '';
                  }
                } else {
                  // on adding coOwners, this is structured correctly.
                  obj[`${key}`] = kr[key];
                }
              } else {
                obj[`${key}`] = kr[key];
              }
            });
			if(obj['kr_duration']){
			obj['kr_duration'] =[];
			}
            if(duration){
              obj["start_date"] = duration.start;
              obj["end_date"] = duration.end;
            } else {
				obj['start_date'] = obj.startDateText;
				obj['end_date'] = obj.endDateText;
			}
            if (typeof kr['metricMirror'] !== 'undefined') {
              obj.mirror_kr_id = kr['metricMirror'].map(k => k.id).join("");
            }
            // A roll-up KR loaded from the server carries its sources only as metricMetric. Without
            // src_metrics the backend deletes its metric_metric links and never re-adds them (OKR-11222).
            if (kr.source == krdetailConstants.SOURCE_METRICS && !kr.src_metrics && Array.isArray(kr.metricMetric)) {
              obj.src_metrics = kr.metricMetric.map(m => (m && typeof m.id !== 'undefined' ? m.id : m));
            }
            nestedKRParams[i] = obj;
        }
    }
	return nestedKRParams;
}


function replaceTxtNotInA(html, regex, replace) {
	//just to make the txt parse easily, without (start) or (ends) issue
	html = ">" + html + "<";

	//parse txt between > and < but not follow with</a
	html = html.replace(/>([^<>]+)(?!<\/a)</g, function (match, txt) {
		//now replace the txt
		return ">" + txt.replace(regex, replace) + "<";

	});

	//remove the head > and tail <
	return html.substring(1, html.length - 1);
}

//wraps links with Anchor tag for KR comment and history
export function replaceLinkWithAnchor(textValue) {
	if (
		typeof textValue === "undefined" ||
		!textValue ||
		textValue.length == 0
	) {
		return textValue;
	}
	let longText = textValue;
	let prefix = 'target=_blank href'
	const result = longText.replace(/(href)/gi, prefix)

	let html = result;
	const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&amp;&@#\/%?=~_|!:,.;]*[-A-Z0-9+&amp;&@#\/%=~_|])/gi;
	html = replaceTxtNotInA(
		html,
		exp,
		"<a href='$1' target='_blank'>$1</a>"
	);

	//URLs starting with "www."
	const exp2 = /\b(www\.[\S]+)\b/gi;
	html = replaceTxtNotInA(
		html,
		exp2,
		'<a href="http://$1" target="_blank">$1</a>'
	);

	//URLs starting with "www."
	const exp3 = /\b(<a href="\.[\S]+)\b/gi;
	html = replaceTxtNotInA(
		html,
		exp3,
		'<a href="http://$1" target="_blank">$1</a>'
	);
	if (typeof html !== 'undefined' && html) {
		html = html.replace(/(<p>&nbsp;<\/p>)*$/i, '');
	}
	return html;
}

export const isReadOnlyUserLicenseType = () => {
	const isReadOnlyLicenseEnabled = wbConfig.userLicenseOrgFeatureFlag || false;
    if (isReadOnlyLicenseEnabled && wbConfig.userLicenseType == 0) {
        return true;
    }
	return false;
}
